import { useNavigate, useLocation } from "react-router-dom";
import { Home, Trophy, BarChart3, User, Plus } from "lucide-react";

const navItems = [
  { id: "home", label: "Accueil", icon: Home, path: "/" },
  { id: "matches", label: "Matchs", icon: Trophy, path: "/matches" },
  { id: "stats", label: "Stats", icon: BarChart3, path: "/stats" },
  { id: "profile", label: "Profil", icon: User, path: "/profile" },
];

export default function BottomNav({ setActiveTab }) {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    const path = location.pathname;
    if (path.startsWith("/match/")) return "matches";
    if (path.startsWith("/profile")) return "profile";
    const item = navItems.find((item) => item.path === path);
    return item ? item.id : "home";
  };

  const handleNavClick = (item) => {
    setActiveTab(item.id);
    navigate(item.path);
  };

  const handleCreateClick = () => {
    // Direct full-page creation flow (no modal).
    navigate("/creer-un-match");
  };

  // Final order: Accueil | Matchs | [ + ] | Stats | Profil
  const left = navItems.slice(0, 2);
  const right = navItems.slice(2);

  const renderItem = (item) => {
    const Icon = item.icon;
    const isActive = getCurrentTab() === item.id;
    return (
      <button
        key={item.id}
        data-testid={`nav-${item.id}`}
        onClick={() => handleNavClick(item)}
        style={{
          flex: 1, display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: '4px',
          padding: '10px 6px', borderRadius: '14px',
          border: 'none', backgroundColor: 'transparent', cursor: 'pointer',
          transition: 'all 0.2s', color: isActive ? '#27ae60' : '#6b7280',
          touchAction: 'manipulation',
        }}
      >
        <Icon
          size={26}
          strokeWidth={isActive ? 2.6 : 2}
          style={{ filter: isActive ? 'drop-shadow(0 0 10px rgba(39,174,96,0.7))' : 'none' }}
        />
        <span className="font-sport uppercase" style={{ fontSize: '11px', fontWeight: isActive ? 700 : 500 }}>
          {item.label}
        </span>
      </button>
    );
  };

  return (
    <nav
      data-testid="bottom-navigation"
      style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, width: '100%',
        backgroundColor: 'rgba(0,0,0,0.95)', backdropFilter: 'blur(12px)',
        borderTop: '1px solid #1a1a1a', zIndex: 9999,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <div
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          height: '72px', maxWidth: '440px', margin: '0 auto', padding: '0 8px',
          gap: '4px',
        }}
      >
        {left.map(renderItem)}

        {/* Central [+] CTA — vertically aligned with the row icons (not the
            column centre) so it sits level with Accueil/Matchs/Stats/Profil. */}
        <button
          type="button"
          data-testid="nav-create-match"
          onClick={handleCreateClick}
          aria-label="Creer un match"
          className="active:scale-95 transition-transform"
          style={{
            flex: '0 0 auto',
            alignSelf: 'flex-start',
            marginTop: '5px',
            width: 44, height: 44,
            borderRadius: 9999,
            border: 'none',
            background: 'linear-gradient(180deg, #22c55e 0%, #16a34a 100%)',
            boxShadow: '0 0 6px rgba(34,197,94,0.55), 0 0 14px rgba(34,197,94,0.18)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', touchAction: 'manipulation',
          }}
        >
          <Plus size={20} strokeWidth={3} color="#fff" />
        </button>

        {right.map(renderItem)}
      </div>
    </nav>
  );
}
